"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditRepay = exports.create = exports.fetchTbpBillAmount = exports.fetchLatestLedgerEntry = exports.fetchAllLedgerEntry = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const ledgerService_1 = require("./service/ledgerService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetchAllLedgerEntry = (0, toolkit_1.createAsyncThunk)('ledger/fetchAllLedgerEntry', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const ledgerService = new ledgerService_1.LedgerService(Env_1.APIPATHENV);
        const response = yield ledgerService.fetchAllLedgerEntry(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error while fetching ledger entry');
    }
}));
exports.fetchLatestLedgerEntry = (0, toolkit_1.createAsyncThunk)('ledger/fetchLatestLedgerEntry', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const ledgerService = new ledgerService_1.LedgerService(Env_1.APIPATHENV);
        const response = yield ledgerService.fetchLatestLedgerEntry(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error while fetching ledger entry');
    }
}));
exports.fetchTbpBillAmount = (0, toolkit_1.createAsyncThunk)('ledger/fetchTbpBillAmount', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const ledgerService = new ledgerService_1.LedgerService(Env_1.APIPATHENV);
        const response = yield ledgerService.fetchTbpBillAmount(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error while fetching ledger entry');
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('ledger/create', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const ledgerService = new ledgerService_1.LedgerService(Env_1.APIPATHENV);
        const response = yield ledgerService.createLedger(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error while creating ledger entry');
    }
}));
exports.creditRepay = (0, toolkit_1.createAsyncThunk)('ledger/creditRepay', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const ledgerService = new ledgerService_1.LedgerService(Env_1.APIPATHENV);
        const response = yield ledgerService.creditRepay(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error while creating ledger entry');
    }
}));
